import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import {
  DEFAULT_LANGUAGE,
  SHORT_TO_FULL_LANGUAGE,
  normalizeLanguage,
} from '../i18nConfig';

export const SUPPORTED_LANGUAGES = new Set(Object.values(SHORT_TO_FULL_LANGUAGE));

export function normalizeSupportedLanguage(language) {
  const normalized = normalizeLanguage(language);
  return SUPPORTED_LANGUAGES.has(normalized) ? normalized : DEFAULT_LANGUAGE;
}

export function createScopedI18n(resources, options = {}) {
  const instance = i18next.createInstance();

  instance.use(initReactI18next).init({
    resources,
    lng: DEFAULT_LANGUAGE,
    fallbackLng: DEFAULT_LANGUAGE,
    defaultNS: 'translation',
    interpolation: {
      escapeValue: false,
    },
    react: {
      useSuspense: false,
    },
    ...options,
  });

  return instance;
}
